/**
 * Favourite cricketers for profile grid. Headshots live at
 * `favs/cricketers/{slug}.png` on cricket8-web-content.
 */
export const PROFILE_FAV_CRICKETER_LOGO_BASE =
  "https://cricket8-web-content.s3.us-east-1.amazonaws.com/favs/cricketers/";

export const PROFILE_FAV_CRICKETER_OPTIONS = [
  { slug: "abhishek-sharma", label: "Abhishek Sharma" },
  { slug: "daryl-mitchell", label: "Daryl Mitchell" },
  { slug: "hardik-pandya", label: "Hardik Pandya" },
  { slug: "jasprit-bumrah", label: "Jasprit Bumrah" },
  { slug: "jos-buttler", label: "Jos Buttler" },
  { slug: "rashid-khan", label: "Rashid Khan" },
  { slug: "kl-rahul", label: "KL Rahul" },
  { slug: "mohammed-siraj", label: "Mohammed Siraj" },
  { slug: "ms-dhoni", label: "MS Dhoni" },
  { slug: "ravindra-jadeja", label: "Ravindra Jadeja" },
  { slug: "rishabh-pant", label: "Rishabh Pant" },
  { slug: "rohit-sharma", label: "Rohit Sharma" },
  { slug: "sanju-samson", label: "Sanju Samson" },
  { slug: "shubman-gill", label: "Shubman Gill" },
  { slug: "suryakumar-yadav", label: "Suryakumar Yadav" },
  { slug: "virat-kohli", label: "Virat Kohli" },
] as const;

export type ProfileFavCricketerSlug = (typeof PROFILE_FAV_CRICKETER_OPTIONS)[number]["slug"];

const OPTION_SLUGS = PROFILE_FAV_CRICKETER_OPTIONS.map((t) => t.slug);
const SLUG_SET = new Set<string>(OPTION_SLUGS);
const SLUG_TO_LABEL: Record<string, string> = Object.fromEntries(
  PROFILE_FAV_CRICKETER_OPTIONS.map((t) => [t.slug, t.label])
);

export function cricketerLogoUrl(slug: string): string {
  return `${PROFILE_FAV_CRICKETER_LOGO_BASE}${encodeURIComponent(slug)}.png`;
}

export function parseFavCricketersFromStorage(raw: string | undefined | null): string[] {
  if (!raw?.trim()) return [];
  const parts = raw
    .split(/,\s*/)
    .map((s) => s.trim())
    .filter(Boolean);
  const ordered: string[] = [];
  for (const slug of OPTION_SLUGS) {
    if (parts.includes(slug)) ordered.push(slug);
  }
  for (const p of parts) {
    if (!SLUG_SET.has(p) && !ordered.includes(p)) ordered.push(p);
  }
  return ordered;
}

export function serializeFavCricketersToStorage(selected: readonly string[]): string {
  if (selected.length === 0) return "";
  const set = new Set(selected);
  const known = OPTION_SLUGS.filter((s) => set.has(s));
  const unknown = selected.filter((s) => !SLUG_SET.has(s));
  return [...known, ...unknown].join(", ");
}

export function favCricketerLabel(slug: string): string {
  return SLUG_TO_LABEL[slug] ?? slug.replace(/-/g, " ");
}
